import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import {
  toggleMegamenu,
  toggleSearchBar,
  toggleNotificationBar,
  setOffcanvas,
} from "../../actions/settingsAction";
import { logOut } from "../Authentication/logout";
import { baseUrl, ROUTE_BASE_URL, localserver } from "../../api/common";
import { useUser } from "../AdminUsers/UserContext";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import { useEvent } from "../Event/EventContext";
import { showToast, ToastMessage } from "../Shared/ToastMessage";

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Header = ({
  toggleMegamenu,
  isMegaMenu,
  toggleNotificationBar,
  toggleSearchBar,
  setOffcanvas,
  offcanvas,
}) => {
  const { adminName, adminProfile, eventUrl, validation, getValidation } = useUser();
  const { eventName, eventStatus, fetchEventDetails, updateEventStatus, eventDetailsUrl } = useEvent();
  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(0);
  // const [validation, setValidation] = useState({
  //   success: false,
  //   can_publish: "No",
  //   message: "",
  //   validation: {},
  // })
  const [showSetupGuide, setShowSetupGuide] = useState(false);
  const setupGuideRef = useRef(null);
  const hoverTimeoutRef = useRef(null);
  const buttonRef = useRef(null);

  const scrollProgress = () => {
    const scrollPx = document.documentElement.scrollTop;
    const winHeightPx =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    setScrolled(`${(scrollPx / winHeightPx) * 100}%`);
  };

  window.addEventListener("scroll", scrollProgress);

  const handleMenuClick = () => {
    setShowDropdown(false);
  };

  function getNotificationIcon(type) {
    switch (type) {
      case 1:
        return "fa-info-circle";
      case 2:
        return "fa-times-circle";
      default:
        return "fa-info-circle";
    }
  }
  function getNotificationColor(type) {
    switch (type) {
      case 1:
        return "bg-green";
      case 2:
        return "bg-warning";
      case 3:
        return "bg-green";
      default:
        return "bg-warning";
    }
  }

  const [notificationData, setNotificationData] = useState([]);
  const fetchNotificationData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/notification_list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        const data = response.data.data.map((item) => ({
          ...item,
          id: item.id,
          type: item.application_status || "",
          icon: getNotificationIcon(item.application_status),
          color: getNotificationColor(item.application_status),
          message:
            `${item.status_name} by ${item.first_name} ${item.last_name}` || "",
        }));
        setNotificationData(data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  function convertNotificationDate(notifyDate) {
    const date = dayjs.utc(notifyDate);
    const now = dayjs();

    if (now.diff(date, "days") > 0) {
      return date.format("DD MMM");
    }
    if (now.diff(date, "hours") > 0) {
      return `${now.diff(date, "hours")} hr`;
    }
    if (now.diff(date, "minutes") > 0) {
      return `${now.diff(date, "minutes")} minutes ago`;
    }
    if (now.diff(date, "seconds") > 0) {
      return `${now.diff(date, "seconds")} seconds ago`;
    }
    return "Just now";
  }

  const changeNotificationReadStatus = async (notificationId, readStatus) => {
    if (readStatus === 0) {
      try {
        const response = await axios.post(
          `${baseUrl}/api/notification_status_update`,
          { id: notificationId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );

        if (response.data.status) {
          console.log(response.data, "response.data");
          fetchNotificationData();
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    }
  };

  const checkEventPublishStatus = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/publish_validation`,
        { event_id: localStorage.getItem("eventId") },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.success && response.data.can_publish === "Yes") {
        console.log(response.data, "response.data");
        updateEventStatus();
      } else if (response.data.success && response.data.can_publish === "No") {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  // const getValidation = async (event_id) => {
  //   try {
  //     const response = await axios.post(
  //       `${localserver}/publish_validation`,
  //       { event_id },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //       },
  //     )
  //     if (response.data.success) {
  //       setValidation(response.data)
  //     } else {
  //       console.error("Error: Failed to fetch validation data")
  //     }
  //   } catch (error) {
  //     console.error("Error fetching validation data:", error)
  //   }
  // }

  const checkEventList = () => {
    const currentPath = window.location.pathname;
    if (
      currentPath === ROUTE_BASE_URL ||
      // currentPath.startsWith === `${ROUTE_BASE_URL}/` ||
      currentPath === `${ROUTE_BASE_URL}/` ||
      currentPath === `${ROUTE_BASE_URL}/my-profile` ||
      currentPath === `${ROUTE_BASE_URL}/event-management` ||
      currentPath === `${ROUTE_BASE_URL}/admin-team` ||
      currentPath === `${ROUTE_BASE_URL}/roles-and-permission` ||
      currentPath === `${ROUTE_BASE_URL}/access-denied` ||
      currentPath === `${ROUTE_BASE_URL}/events-dashboard`
    ) {
      return false;
    }
    return true;
  };

  const handleCopy = async (url, type = "Link") => {
    try {
      await navigator.clipboard.writeText(url);
      showToast(`Event ${type} Copied`, "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleOpenNewTab = (url) => {
    window.open(url, '_blank');
  };

  const handleMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setShowSetupGuide(true);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setShowSetupGuide(false);
    }, 300); // 300ms delay to allow moving from button to panel
  };

  const handlePanelMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
  };

  const handlePanelMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setShowSetupGuide(false);
    }, 300);
  };

  useEffect(() => {
    if (localStorage.getItem("eventId")) {
      fetchEventDetails(localStorage.getItem("eventId"));
      getValidation();
    }
    // fetchNotificationData();
  }, [localStorage.getItem("eventId")]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        setupGuideRef.current &&
        !setupGuideRef.current.contains(event.target)
      ) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetupGuide(false);
        }
      }
    };

    if (showSetupGuide) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, [showSetupGuide]);

  const steps = [
    {
      name: "Basic information",
      status:
        validation.validation?.EventInformation?.status === "Yes"
          ? "active"
          : "inactive",
      link: `${ROUTE_BASE_URL}/event-registration-info`,
    },
    {
      name: "Settings",
      status:
        validation.validation?.Settings?.status === "Yes"
          ? "active"
          : "inactive",
      link: `${ROUTE_BASE_URL}/settings`,
    },
    {
      name: "Payment settings",
      status:
        validation.validation?.PaymentSettings?.status === "Yes"
          ? "active"
          : "inactive",
      link: `${ROUTE_BASE_URL}/payment-settings`,
    },
    {
      name: "Tax setup",
      status:
        validation.validation?.Settings?.status === "Yes"
          ? "active"
          : "inactive",
      link: `${ROUTE_BASE_URL}/settings`,
    },
    {
      name: "Tickets",
      status:
        validation.validation?.Tickets?.status === "Yes"
          ? "active"
          : "inactive",
      link: `${ROUTE_BASE_URL}/event-tickets`,
    },
    {
      name: "Email setup",
      status:
        validation.validation?.Emails?.status === "Yes" ? "active" : "inactive",
      link: `${ROUTE_BASE_URL}/event-emails`,
    },
    {
      name: "Go live",
      status: validation.can_publish === "Yes" ? "active" : "inactive",
      link: "#",
    },
  ];

  const lastActiveIndex = steps.reduce((maxIndex, step, index) => {
    return step.status === "active" ? Math.max(maxIndex, index) : maxIndex;
  }, -1);

  return (
    <>
      <ToastMessage />
      <nav className="navbar top-navbar">
        <div className="container-fluid">
          <div className="navbar-left d-flex">
            {/* <ul className="nav navbar-nav">
              <li className="dropdown">
                <span className="dropdown-toggle icon-menu" data-toggle="dropdown">
                  <i className="icon-bell"></i>
                  {notificationData.filter((data) => data.read_status === 0).length > 0 && <span className="notification-dot bg-azura">{notificationData.filter((data) => data.read_status === 0).length}</span>}
                </span>
                <ul className="dropdown-menu feeds_widget vivify fadeIn notification_overflow">
                  <li className="header blue">{notificationData.filter((data) => data.read_status === 0).length > 0 ? `You have ${notificationData.length} New Notifications` : "Notifications"}</li>
                  {notificationData.map((notification) => (
                    <li onClick={() => changeNotificationReadStatus(notification.id, notification.read_status)} key={notification.id} className={`${notification.read_status === 0 ? "active_div_notification" : ''}`}>
                      <Link to={`${ROUTE_BASE_URL}/`}>
                        <div className={`feeds-left ${notification.color} text-white`}>
                          <i className={`fa ${notification.icon}`}></i>
                        </div>
                        <div className="feeds-body custom_date">
                          <div className='message_custom'>
                            <h4 className="title text-dark" dangerouslySetInnerHTML={{ __html: notification.message }}></h4>
                          </div>
                          <div className='notification_date_custom float-right text-muted'>
                            {convertNotificationDate(notification.created_on)}
                          </div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            </ul> */}
            <button
              type="button"
              className="btn-toggle-offcanvas btn btn-sm me-3 d-xl-none"
              onClick={() => setOffcanvas(!offcanvas)}
              aria-label="Toggle sidebar"
            >
              <i className={`fa ${offcanvas ? "fa-times" : "fa-bars"}`}></i>
            </button>

            {checkEventList() && (
              <div className="event_tittle_header">
                <Link to={`${ROUTE_BASE_URL}/`}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                <h4>
                  {eventName}{" "}
                  <span className="fee_table_free">{eventStatus}</span>
                </h4>
              </div>
            )}
          </div>
          <div className="navbar-right header_menu_align ">
           {(eventDetailsUrl && checkEventList() && eventStatus === "published") && (
              <Dropdown>
                <Dropdown.Toggle variant="outline-primary" id="event-details-dropdown">
                  Event Details Link
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleCopy(eventDetailsUrl, "Details Link")}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" className="me-1">
                      <path fillRule="evenodd" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"></path>
                      <path fillRule="evenodd" d="M5 2.75C5 1.784 5.784 1 6.75 1h4.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0111.25 10H6.75A1.75 1.75 0 015 8.25v-5.5zM6.75 2.5a.25.25 0 00-.25.25v5.5c0 .138.112.25.25.25h4.5a.25.25 0 00.25-.25v-5.5a.25.25 0 00-.25-.25h-4.5z"></path>
                    </svg>
                    Copy
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleOpenNewTab(eventDetailsUrl)}>
                    <svg data-v-6f029f02="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" className="me-1"><path data-v-6f029f02="" fill="currentColor" d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-64 47.111C384 109.929 370.071 96 352.889 96H220.667c-12.887 0-23.333 10.447-23.333 23.334v14.904c0 13.138 10.843 23.686 23.976 23.324l56.002-1.588L69.908 361.908c-7.858 7.802-7.88 20.504-.05 28.334l19.899 19.899c7.83 7.83 20.532 7.808 28.334-.05l205.935-207.404-1.588 56.003c-.362 13.133 10.186 23.976 23.324 23.976h14.904c12.887 0 23.334-10.447 23.334-23.333V127.111z" class=""></path></svg>
                    Open in New Tab
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {checkEventList() && eventStatus === "published" && (
              <Dropdown>
                <Dropdown.Toggle variant="outline-primary" id="event-link-dropdown">
                  Event Link
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => {
                    handleCopy(eventUrl, "Link");
                    handleMenuClick();
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" className="me-1">
                      <path fillRule="evenodd" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"></path>
                      <path fillRule="evenodd" d="M5 2.75C5 1.784 5.784 1 6.75 1h4.5c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0111.25 10H6.75A1.75 1.75 0 015 8.25v-5.5zM6.75 2.5a.25.25 0 00-.25.25v5.5c0 .138.112.25.25.25h4.5a.25.25 0 00.25-.25v-5.5a.25.25 0 00-.25-.25h-4.5z"></path>
                    </svg>
                    Copy
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => {
                    handleOpenNewTab(eventUrl);
                    handleMenuClick();
                  }}>
                    <svg data-v-6f029f02="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="external-link-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" className="me-1"><path data-v-6f029f02="" fill="currentColor" d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-64 47.111C384 109.929 370.071 96 352.889 96H220.667c-12.887 0-23.333 10.447-23.333 23.334v14.904c0 13.138 10.843 23.686 23.976 23.324l56.002-1.588L69.908 361.908c-7.858 7.802-7.88 20.504-.05 28.334l19.899 19.899c7.83 7.83 20.532 7.808 28.334-.05l205.935-207.404-1.588 56.003c-.362 13.133 10.186 23.976 23.324 23.976h14.904c12.887 0 23.334-10.447 23.334-23.333V127.111z" class=""></path></svg>
                    Open in New Tab
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {checkEventList() && eventStatus !== "published" && (
              <>
                <div
                  ref={buttonRef}
                  className="  event_stepup_process mr-2"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => setShowSetupGuide(!showSetupGuide)}
                >
                  Event Setup Progress{" "}
                  <i
                    className={`fa ${
                      showSetupGuide ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  ></i>
                </div>
                <div>
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-outline-primary "
                      onClick={() => checkEventPublishStatus()}
                    >
                      Publish Event
                    </button>
                  </div>
                </div>
              </>
            )}
            <div className="user-account d-flex">
              <div className="user_div">
                {/* <p>
                  {localStorage.getItem("loginUserName").charAt(0).toUpperCase()}
                </p> */}
                <img
                  src={`${"https://member2025.s3.ap-south-1.amazonaws.com/events/user.jpeg"}`}
                  width={50}
                  height={50}
                  className="user-photo rounded img-thumbnail rounded-circle profile-menu-size"
                  alt="User Profile"
                />
              </div>
              <div className="dropdown">
                <span>Welcome,</span>
                <br />
                <Dropdown
                  show={showDropdown}
                  onToggle={(isOpen) => setShowDropdown(isOpen)}
                  className="ml-0"
                >
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="user-name left_dropdown_btn profile_name_header"
                  >
                    <strong>
                      {localStorage.getItem("loginUserName") || ""}
                    </strong>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link
                      className="dropdown-item"
                      to={`${ROUTE_BASE_URL}/my-profile`}
                      onClick={handleMenuClick}
                    >
                      <i className="icon-user"></i> My Profile
                    </Link>
                    {/* <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={handleMenuClick}>
                        <i className="icon-envelope-open"></i> Messages
                          </Link>
                        <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={handleMenuClick}>
                          <i className="icon-settings"></i> Settings
                        </Link> */}
                    {/* <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/settings`} onClick={handleMenuClick}>
                      <i className="icon-settings"></i> Settings
                    </Link> */}
                    <Link
                      className="dropdown-item"
                      to={`${ROUTE_BASE_URL}/login`}
                      onClick={() => {
                        logOut();
                        handleMenuClick();
                      }}
                    >
                      <i className="icon-power"></i> Logout
                    </Link>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <div className="progress-container">
          <div
            style={{ width: scrolled }}
            className="progress-bar"
            id="myBar"
          ></div>
        </div>
      </nav>

      {checkEventList() && eventStatus !== "published" && showSetupGuide && (
        <div
          ref={setupGuideRef}
          onMouseEnter={handlePanelMouseEnter}
          onMouseLeave={handlePanelMouseLeave}
          style={{
            position: "fixed",
            top: "68px",
            right: "20px",
            width: "400px",
            maxHeight: "calc(100vh - 100px)",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            zIndex: 1000,
            padding: "24px",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h5
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: 600,
                color: "#1f2937",
              }}
            >
              Event Setup Progress
            </h5>
            <div
              className="close_icon_process"
              onClick={() => setShowSetupGuide(false)}
              style={
                {
                  // background: "none",
                  // border: "none",
                  // fontSize: "20px",
                  // cursor: "pointer",
                  // color: "#6b7280",
                  // padding: "0",
                  // lineHeight: 1,
                }
              }
            >
              <i class="icon-close"></i>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
            {steps.map((step, index) => (
              <Link
                key={index}
                to={step.link}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  position: "relative",
                  cursor: step.name !== "Go live" ? "pointer" : "default",
                  textDecoration: "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      backgroundColor:
                        step.status === "active" ? "#28a745" : "#dc3545",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      fontWeight: 600,
                      flexShrink: 0,
                    }}
                  >
                    {step.status === "active" ? (
                      <i className="fa fa-check"></i>
                    ) : (
                      index + 1
                    )}
                  </div>
                  {index < steps.length - 1 && (
                    <div
                      style={{
                        width: "2px",
                        height: "32px",
                        backgroundColor:
                          index < lastActiveIndex ? "#28a745" : "#dc3545",
                        marginTop: "4px",
                      }}
                    />
                  )}
                </div>
                <div style={{ flex: 1, paddingTop: "4px" }}>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: step.status === "active" ? "#1f2937" : "#6b7280",
                      marginBottom: "4px",
                    }}
                  >
                    {step.name}
                  </div>
                  <div style={{ fontSize: "12px", color: "#9ca3af" }}>
                    {step.status === "active" ? "Completed" : "Pending"}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isMegaMenu: state.settings.isMegaMenu,
  offcanvas: state.settings.offcanvas,
});

const mapDispatchToProps = (dispatch) => ({
  toggleMegamenu: (e) => dispatch(toggleMegamenu(e)),
  toggleSearchBar: (e) => dispatch(toggleSearchBar(e)),
  toggleNotificationBar: (e) => dispatch(toggleNotificationBar(e)),
  setOffcanvas: (e) => dispatch(setOffcanvas(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);